export type ButtonProps = {
  extraClasses?: string
  isDisabled?: boolean
  isFullWidth?: boolean
  isFullWidthMobile?: boolean
  isInverse?: boolean
  link?: string
  isNotSubmit?: boolean
  onClick?: (e?: any) => void
  type?: ButtonTypes
  withArrow?: boolean
  withGradient?: boolean
}

export enum ButtonTypes {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  TERNARY = 'ternary'
}
